import { Trans } from "react-i18next";
import { Typography } from "@mui/material";
import { useBrandingContext } from "context/BrandingContext";
import { Center } from "components/layout/reusableLayouts";

interface TermsAndPrivacyNoticeProps {
  className?: string;
}

/**
 * The passive form: submitting is the agreement, so there is nothing to tick.
 * Where consent has to be given explicitly, use TermsAcceptanceCheckbox.
 */
const TermsAndPrivacyNotice: React.FC<TermsAndPrivacyNoticeProps> = ({
  className,
}) => {
  const { platform } = useBrandingContext();

  // Not "": an empty href resolves to the current page, so target="_blank"
  // would reopen the app in a new tab when a platform configures no link.
  const termsUrl = platform?.termsUrl || undefined;
  const privacyUrl = platform?.privacyUrl || undefined;

  return (
    <Center className={className} sx={{ width: "100%" }}>
      <Typography
        variant="body2"
        component="p"
        sx={{
          color: "var(--color-text-tertiary)",
          fontSize: "var(--type-size-sm)",
          "& a": {
            // The package has shipped --color-text-link since 0.7.2. It equals
            // --color-text-brand in the one brand shipping today, and did not
            // in 0.7.2's three, so the semantic token is the safe one.
            color: "var(--color-text-link)",
            fontWeight: "var(--type-weight-medium)",
            textDecoration: "none",
            "&:hover": { textDecoration: "underline" },
          },
        }}
      >
        <Trans i18nKey="termsAndPrivacy">
          By clicking submit, you agree to the
          {termsUrl ? (
            <a target="_blank" rel="noopener noreferrer" href={termsUrl}>
              Terms
            </a>
          ) : (
            <span>Terms</span>
          )}
          and
          {privacyUrl ? (
            <a target="_blank" rel="noopener noreferrer" href={privacyUrl}>
              Privacy Policy
            </a>
          ) : (
            <span>Privacy Policy</span>
          )}
        </Trans>
      </Typography>
    </Center>
  );
};

export default TermsAndPrivacyNotice;
